module.exports = __webpack_public_path__ + "static/media/christen.4cadd5ee.jpg";